module.exports = __webpack_public_path__ + "media/images/logo_2x-b377f709c9e7d0723d5cc50dc210c92a.png";